<template>

    <form autocomplete="off" v-on:submit.prevent="saveData" class="trax-form-with-icons">

        <trax-ui-search-remote-object icon="list_alt" v-model="value.program_id"
            :endpoint="programs_endpoint" :filters="status_filters"
            :placeholder="lang.polaris.training.program"
            :unselectedLabel="lang.polaris.training.search_program"
            :noOptionLabel="lang.polaris.training.no_program_found"
            :unselect="true"
        ></trax-ui-search-remote-object>

        <trax-ui-search-remote-object icon="people" v-model="value.cohort_id"
            :endpoint="groups_endpoint" :filters="status_filters"
            :placeholder="lang.polaris.account.group"
            :unselectedLabel="lang.polaris.account.search_group"
            :noOptionLabel="lang.polaris.account.no_group_found"
            :unselect="true"
        ></trax-ui-search-remote-object>

        <trax-ui-datetime icon="event_available" :placeholder="lang.polaris.training.from_date"
            v-model="value.from" type="date"
        ></trax-ui-datetime>

        <trax-ui-datetime icon="event_available" :placeholder="lang.polaris.training.to_date"
            v-model="value.to" type="date"
        ></trax-ui-datetime>

        <trax-ui-checkbox :text="lang.polaris.tasks.night_run" v-model="night"></trax-ui-checkbox>

        <div class="trax-form-actions text-right">
            <button type="submit" class="btn btn-round btn-primary">
                {{ lang.polaris.dashboard.generate }} CSV
            </button>
        </div>
    </form>
    
</template>

<script>
    export default {
    
        props: {
            id: null,
            value: null,
            bus: null,
        },

        data: function() {
            return {
                lang: lang,
                programs_endpoint: app_url + 'polaris/api/front/programs/select',
                groups_endpoint: app_url + 'polaris/api/front/cohorts/select',
                status_filters: {status: {$in: ['active', 'archived']}},

                // The export is heavy: it waits for the night unless the user says otherwise.
                night: true,
            }
        },

        watch: {

            night: function(value) {
                this.value.lane = value ? 'night' : 'now';
            }
        },

        methods: {

            saveData() {
                this.bus.$emit(this.id+'-close');
                this.bus.$emit(this.id+'-generate');
            },
        }
    }
</script>
